import React from "react";
import styled from "styled-components";
import { Button, SearchInput } from "components";
import { useTransformsContext } from "contexts";
import { useModal } from "hooks";
import { CreateTransformBlockModal, ManageGroupsModal } from "modals";

export const SearchBar = ({ onSearch = () => {}, isLoading }) => {
  const { query, setQuery, totalCount } = useTransformsContext();
  const createBlockModal = useModal();
  const manageGroupsModal = useModal();

  const handleCreateBlock = () => {
    createBlockModal.openModal();
  };

  const handleManageGroups = () => {
    manageGroupsModal.openModal();
  };

  return (
    <Container>
      <LeftPanel>
        <SearchContainer>
          <SearchInput
            placeholder={`Search ${totalCount} Transforms`}
            className="my-auto w-100"
            value={query}
            onChange={setQuery}
            onEnter={() => onSearch(query)}
            disabled={isLoading}
          />
        </SearchContainer>
        <Button
          size="small"
          buttonTheme="dark"
          width="fit-content"
          className="my-auto ml-3"
          disabled={isLoading}
          onClick={() => onSearch()}
        >
          Search
        </Button>
      </LeftPanel>
      <RightPanel>
        <Button
          width="140px"
          size="small"
          buttonTheme="dark"
          className="ml-2 my-auto"
          onClick={handleCreateBlock}
        >
          Create Block
        </Button>
        <Button
          width="160px"
          size="small"
          buttonTheme="dark"
          className="ml-2 my-auto"
          onClick={handleManageGroups}
        >
          Manage Groups
        </Button>
      </RightPanel>
      <CreateTransformBlockModal {...createBlockModal} />
      <ManageGroupsModal {...manageGroupsModal} />
    </Container>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.palette.backgrounds};
  height: 50px;
  display: flex;
  padding: 0 24px;
  margin-bottom: 2px;
`;
const LeftPanel = styled.div`
  flex: 1;
  padding-left: 0px;
  padding-right: 24px;
  display: flex;
`;
const SearchContainer = styled.div`
  display: flex;
  flex: 1;
`;
const RightPanel = styled.div`
  border-left: 4px solid ${(props) => props.theme.palette.canvas};
  padding: 0 0 0 24px;
  display: flex;
`;
